var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-content',[_c('section',[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},[_c('h1',{staticClass:"display-4 text-xs-center mt-200"},[_vm._v("Forbidden")])])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }